var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGooglePlayOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5 11.4019C26.5 12.5566 26.5 15.4434 24.5 16.5981L9.5 25.2583C7.5 26.413 5 24.9697 5 22.6603V5.33975C5 3.03035 7.5 1.58698 9.5 2.74167L24.5 11.4019ZM23.5 14.866C24.1667 14.4811 24.1667 13.5189 23.5 13.134L20.2154 11.2376L17.6504 14L20.2154 16.7624L23.5 14.866ZM18.4387 17.7882L9.1565 23.1473L16.2857 15.4696L18.4387 17.7882ZM16.2857 12.5304L9.15641 4.85271L18.4387 10.2118L16.2857 12.5304ZM7 5.46964L7 22.5304L14.9211 14L7 5.46964Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlayOutline);
export default __webpack_public_path__ + "static/media/google_play_outline.757c6bd2d5acba108d3e9164b4b11124.svg";
export { ForwardRef as ReactComponent };